import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);

const BookingBar = () => {
    const baseUrl =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_BASE_URL_DEV
            : process.env.REACT_APP_BASE_URL_PROD;

    const [dayWiseCount, setDayWiseCount] = useState([]);

    useEffect(() => {
        const fetchBookings = async () => {
            try {
                const response = await fetch(`${baseUrl}/adminbooking/allbookings`);
                const result = await response.json();
                const bookings = result.message.bookingsData || [];

                const today = new Date();
                const currentMonth = today.getMonth();
                const currentYear = today.getFullYear();
                const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

                const counts = Array(daysInMonth).fill(0);

                bookings.forEach(b => {
                    const date = new Date(b.createdAt);
                    if (date.getMonth() === currentMonth && date.getFullYear() === currentYear) {
                        const day = date.getDate();
                        counts[day - 1]++;
                    }
                });

                setDayWiseCount(counts);
            } catch (error) {
                console.error("Error fetching bookings:", error);
            }
        };

        fetchBookings();
    }, [baseUrl]);

    // ✅ X-Axis like "01 April", "02 April"
    const monthName = new Date().toLocaleString('default', { month: 'long' });
    const labels = Array.from({ length: dayWiseCount.length }, (_, i) => `${String(i + 1).padStart(2, '0')} ${monthName}`);

    const gradient = (ctx) => {
        const gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, "#3354F4");
        gradient.addColorStop(1, "#FFFFFF00");
        return gradient;
    };

    const data = {
        labels: labels,
        datasets: [
            {
                label: "Current Month",
                data: dayWiseCount,
                borderColor: "#27648B",
                backgroundColor: (context) => gradient(context.chart.ctx),
                tension: 0.4,
                fill: true,
                pointRadius: 5,
                pointBackgroundColor: "#FFFFFF",
                pointBorderColor: "#27648B",
                pointBorderWidth: 1,
                borderWidth: 2,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.parsed.y}%`
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                max: 100,
                ticks: {
                    stepSize: 20,
                    callback: (value) => `${value}%`,  // ✅ shows % in Y-Axis
                },
            },
            x: {
                grid: { display: false },
            },
        },
        animation: {
            duration: 3000,
            easing: "easeInOutCubic",
        },
    };

    return (
        <div className="w-[320px] lg:w-full p-4 sm:p-6 lg:p-8 bg-white rounded-lg shadow-md">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-[#252C58]">Booking Status - {monthName}</h2>
            </div>
            <div className="w-full h-[150px] sm:h-[300px] md:h-[350px] lg:h-[290px]">
                <Line data={data} options={options} />
            </div>
        </div>
    );
};

export default BookingBar;
